<script setup>
import { useAttrs, computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');

const logoSrc = computed(() => {
  return globalConfig.value?.logoThumbnail || '/brand-assets/logo_thumbnail.svg';
});
</script>

<template>
  <img
    v-bind="attrs"
    :src="logoSrc"
    alt="Logo"
    class="object-contain w-full h-full max-h-full max-w-full"
  />
</template>
